import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService } from '../../../../services/data.service';
import { LocationService } from '../../../../services/location.service';
import { RouterService } from '../../../../services/router.service';
import { SecurityService } from '../../../../services/security.service';
import { ErrorStateMatcher1 } from '../../../error-state-matcher1';
import { IccResponse } from '../../../Interfaces/icc';
import { ILocationUpdateV1 } from '../../../Interfaces/ilocation';

@Component({
  selector: 'app-locationedit',
  templateUrl: './locationedit.component.html'
})

export class LocationEditComponent implements OnInit {
  formEdit: FormGroup;
  subRef$: Subscription;
  matcher = new ErrorStateMatcher1();
  message: string = "";
  Cc: IccResponse[] = [];
  ccList = null;
  r_ccregs: 0;
  locationId: number;
  locationCode:string;
  route: string;

  constructor(
    private formBuilder: FormBuilder, 
    private dataService: DataService,
    private securityService: SecurityService,
    private router: Router,
    private locationservice: LocationService,
    private _snackBar: MatSnackBar,
    private securityParams: ActivatedRoute,
    private routeparent: RouterService,
    private dialogRef: MatDialogRef<LocationEditComponent>,
    @Inject(MAT_DIALOG_DATA) public paramData: any
  ) {
    this.formEdit = formBuilder.group({
      name: ['', Validators.required]
    //  ,ccid: [0]
    });
  }
  selectedvalue: number; selectedview: string;

  Get(id:number) {
    this.locationservice.Get(id).subscribe(result => {
      if (result.body.isValid) {
        this.locationCode = result.body.resultData.code;
        this.formEdit.controls['name'].setValue(result.body.resultData.name);
      }
      else {
        this.message = result.body.error.description;
      }
    }, (e) => {
      alert(e);
    })
  }

  ngOnInit() {
    //this.locationId = parseInt(this.securityParams.snapshot.params.locationid);
    this.locationId = this.paramData.locationid;
    this.message = "";
    this.Get(this.locationId);
  }

  Save()
  {
    try {
      const data: ILocationUpdateV1 = {
        id: this.locationId,
        name: this.formEdit.value.name,
        company_id: 0
      };
      this.locationservice.UpdateV1(data).subscribe(results => {
        if (results.ok) {
          this.openSB("Ubicación grabada");
          this.dialogRef.close(true);
        }
        else { alert("Error"); }
      },
        (e) => {
          alert(e.error);
        }
      );
    }
    catch (e) {
      console.log(e.message);
      alert(e.message);
    }
  }

  Cancel()
  {
    this.dialogRef.close(false);
  }

  hasError(nombreControl: string, validacion: string) {
    const control = this.formEdit.get(nombreControl);
    return control.hasError(validacion);
  }

  openSB(msg) {
    this._snackBar.open(msg,'', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }


}
